import { ToggleGroup, ToggleGroupItem } from '@/components/ui/toggle-group'

export interface Tab<T extends string> {
  id: T
  name: string
  disabled: boolean
}

interface Props<T extends string> {
  tabs: Tab<T>[]
  currentTabs: T[]
  onTabChanged: (filter: string[]) => void
}

export function defineTab<T extends string>(id: T, name: string, disabled = false): Tab<T> {
  return { id, name, disabled }
}

export function SearchTab<T extends string>({
  tabs,
  currentTabs,
  onTabChanged,
}: Props<T>): JSX.Element {
  return (
    <ToggleGroup variant='outline' value={currentTabs} multiple spacing={2}>
      {tabs.map((tab) => (
        <ToggleGroupItem
          value={tab.id}
          onClick={() => {
            if (currentTabs.includes(tab.id)) {
              onTabChanged(currentTabs.filter((currentTab) => currentTab !== tab.id))
            } else {
              onTabChanged([...currentTabs, tab.id])
            }
          }}
          aria-label={tab.name}
        >
          {tab.name}
        </ToggleGroupItem>
      ))}
    </ToggleGroup>
  )
}
